import {axiosNodeClient} from "../http/axiosNodeClient";
import {appLocalStorage} from "../../../_helpers/AppConts";
import {logoutAuthorized} from "../../../_helpers/HNTUtil";

export const authenticationServiceNode = {login, logout}

function login (username, password) {
    return axiosNodeClient.post('/user/auth/login', {username, password})
        .then (
            loginInfo => {
                logoutAuthorized();
                let user = loginInfo.user;
                let store = loginInfo.store;
                let token = loginInfo.token_node;
                if (user) {
                    localStorage.setItem(appLocalStorage.USER, JSON.stringify(user));
                }
                if (store) {
                    localStorage.setItem(appLocalStorage.STORE, JSON.stringify(store));
                }
                if (token) {
                    localStorage.setItem(appLocalStorage.TOKENNODE, token);
                }
                return loginInfo;
            },
            err => {
                throw err;
            }
        );
}

function logout() {
    return axiosNodeClient.delete('/user/auth/logout')
        .then(
            res => {
                logoutAuthorized();
                return res;
            },
            err => {
                throw err;
            }
        )
}
